import { useExamStore } from "@store";
import { motion } from "framer-motion";
import { useCallback, useEffect, useState } from "react";
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { Draggable } from "../common/Draggable";
import { Droppable } from "../common/Droppable";
import { Space } from "antd";
import { SortableContext } from "@dnd-kit/sortable";

export const ConnectingOption = () => {
  const currentQuestion = useExamStore((state) => state.clickedQuestion);
  const droppableIds =
    currentQuestion?.answers.map((answer) => answer.value) || [];
    const [activeId, setActiveId] = useState();
  const [draggables, setDraggables] = useState(
    currentQuestion?.answers.map((answer) => ({
      id: answer.id,
      answer: answer.pairAnswerText,
      parent: "default",
    })) || []
  );

  const handleDragEnd = ({ active, over }: any) => {
    if (over) {
      setDraggables((prevDraggables) => {
        // First, find the draggable that was moved and its current position
        const movingItemIndex = prevDraggables.findIndex(
          (item) => item.id === active.id
        );
        const movingItem = prevDraggables[movingItemIndex];
  
        // Handle case where the target is the same as the original droppable
        if (over.id === movingItem.id) {
          return prevDraggables; // No changes needed
        }
  
        // Handle case where the target is the 'default' droppable or the item is being moved from 'default'
        if (over.id === "default" || movingItem.parent === "default") {
          // Simply assign the new parent if moving to 'default' or from 'default' without swapping
          return prevDraggables.map((item) =>
            item.id === active.id ? { ...item, parent: over.id } : item
          );
        } else {
          // For all other droppables, ensure only one item per droppable by swapping places
          // Find if there's an item in the target droppable
          const targetItemIndex = prevDraggables.findIndex(
            (item) => item.id === over.id
          );
  
          const updatedDraggables = prevDraggables.map((item, index) => {
            if (index === movingItemIndex) {
              // Move the active item to the new droppable
              return { ...item, parent: over.id };
            } else if (index === targetItemIndex) {
              // Move the existing item in the target droppable back to the active item's previous droppable
              return { ...item, parent: movingItem.parent };
            }
            return item;
          });
  
          return updatedDraggables;
        }
      });
    }
  };
  
  const  handleDragStart = (event: any) => {
    const {active} = event;
    const {id} = active;  
    setActiveId(id);
  }

  const handleDragCancel = useCallback(() => {
    setActiveId(undefined);
}, []);

  useEffect(() => {
    console.log(currentQuestion);
  }, [currentQuestion]);

  const sensors = useSensors(useSensor(PointerSensor));

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
      style={{ width: "100%", position: "relative" }}
    >
      <DndContext
        sensors={sensors}
        onDragEnd={handleDragEnd}
        onDragStart={handleDragStart}
        onDragCancel={handleDragCancel}
      >
        <SortableContext items={draggables}>
          <Droppable key="default" id="default">
            {draggables
              .filter((item) => item.parent === "default")

              .map((filteredItem) => (
                <Draggable
                  key={filteredItem.id}
                  id={filteredItem.id}
                  test="test"
                >
                  {filteredItem.answer}
                </Draggable>
              ))}
          </Droppable>
        </SortableContext>
        <Space style={{ display: "flex", marginTop: 8 }} wrap>
          {droppableIds.map((droppableId) => (
            <Droppable key={droppableId} id={droppableId}>
              {draggables
                .filter((item) => item.parent === droppableId)
                .map((filteredItem) => (
                  <Draggable key={filteredItem.id} id={filteredItem.id}>
                    {filteredItem.answer}
                  </Draggable>
                ))}
            </Droppable>
          ))}
        </Space>
        <DragOverlay style={{ transformOrigin: "0 0 " }}>
          {activeId ? (
            <Draggable id={activeId}>
              {draggables.filter((item) => item.id === activeId)[0]?.answer}
            </Draggable>
          ) : null}
        </DragOverlay>
      </DndContext>
    </motion.div>
  );
};
